import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Button from '../../../../components/Button'
import CallToActionFields from '../../../ReusableFormFields/CallToActionFields'
import GoogleAdPreviewDisplay1 from '../GoogleAssetsSliderPreview/Previews/GoogleAdPreviewDisplay1'

import { googleAdsCallToActionList } from '../../../../constants/selectLists/googleAdsCallToActionList'

import useStyles from '../../../../styles/common/stepForms'

function CallToActionStep({ formik, handleStepChange }) {
  const { t } = useTranslation()
  const commonClasses = useStyles()

  const { values } = formik

  const handleContinue = useCallback(() => {
    handleStepChange()
  }, [handleStepChange])

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('What should the call-to-action be?')}</div>
      <div className={commonClasses.stepBody}>
        <GoogleAdPreviewDisplay1 values={values} />
        <CallToActionFields formik={formik} actionsList={googleAdsCallToActionList} preselectDefaultValue />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

CallToActionStep.propTypes = {
  handleStepChange: PropTypes.func,
  formik: PropTypes.object
}

export default CallToActionStep
